import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import {
    GET_SLACK_AUTHORIZATION,
    GET_SLACK_AUTHORIZATION_URL,
    UNINSTALL_SLACK,
    LIST_SLACK_CHANNELS,
    CREATE_SLACK_CHANNEL,
    CREATE_EVENT_SUBSCRIPTION,
    DELETE_EVENT_SUBSCRIPTION,
    GET_EVENT_SUBSCRIPTION
} from './types.js';

export const INITIAL_STATE = {
    config: null,
    error: null,
    isLoading: false,
    responseName: null,
    channels: null
};

export const slackReducer = produce((draft, action) => {
    switch (action.type) {
        case CREATE_EVENT_SUBSCRIPTION.STARTED:
        case CREATE_SLACK_CHANNEL.STARTED:
        case DELETE_EVENT_SUBSCRIPTION.STARTED:
        case GET_EVENT_SUBSCRIPTION.STARTED:
        case GET_SLACK_AUTHORIZATION_URL.STARTED:
        case GET_SLACK_AUTHORIZATION.STARTED:
        case LIST_SLACK_CHANNELS.STARTED:
        case UNINSTALL_SLACK.STARTED: {
            draft.isLoading = true;
            break;
        }
        case GET_EVENT_SUBSCRIPTION.SUCCEEDED: {
            draft.error = null;
            draft.eventSubscription = action.payload;
            break;
        }
        case GET_SLACK_AUTHORIZATION.SUCCEEDED: {
            draft.config = action.payload;
            draft.responseName = action.responseName;
            break;
        }
        case CREATE_EVENT_SUBSCRIPTION.SUCCEEDED:
        case CREATE_SLACK_CHANNEL.SUCCEEDED:
        case DELETE_EVENT_SUBSCRIPTION.SUCCEEDED:
            draft.error = null;
            break;
        case LIST_SLACK_CHANNELS.SUCCEEDED: {
            draft.error = null;
            draft.channels = Object.entries(action.payload.channels).map(([name, id]) => ({
                name,
                id
            }));
            break;
        }
        case GET_EVENT_SUBSCRIPTION.FAILED: {
            draft.eventSubscription = null;
            draft.isLoading = false;
            break;
        }
        case CREATE_EVENT_SUBSCRIPTION.FAILED:
        case DELETE_EVENT_SUBSCRIPTION.FAILED:
        case GET_SLACK_AUTHORIZATION.FAILED:
        case LIST_SLACK_CHANNELS.FAILED:
        case CREATE_SLACK_CHANNEL.FAILED:
        case GET_SLACK_AUTHORIZATION_URL.FAILED: {
            draft.error = extractError(action.payload);
            draft.responseName = null;
            draft.isLoading = false;
            break;
        }
        case GET_EVENT_SUBSCRIPTION.ENDED:
        case CREATE_EVENT_SUBSCRIPTION.ENDED:
        case DELETE_EVENT_SUBSCRIPTION.ENDED:
        case LIST_SLACK_CHANNELS.ENDED:
        case CREATE_SLACK_CHANNEL.ENDED:
        case GET_SLACK_AUTHORIZATION.ENDED: {
            draft.isLoading = false;
            break;
        }
        case UNINSTALL_SLACK.ENDED: {
            return INITIAL_STATE;
        }
        default:
            break;
    }
}, INITIAL_STATE);
